import { Box } from "@mui/material";
import React, { useState } from "react";
import { useOutlet } from "react-router";
import { AppBar, SideDrawer, TopNotifications } from "@/features";
import { usePermissionsSync } from "@/hooks";
import { RequiredModels } from "@/components";

const drawerWidth = 260;

/**
 *
 */
export const AppLayout = () => {
  usePermissionsSync();
  const children = useOutlet();

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <Box
      sx={{
        display: "flex",
      }}
    >
      <AppBar
        drawerWidth={drawerWidth}
        toggleDrawer={() => setIsDrawerOpen((open) => !open)}
      />
      <SideDrawer
        drawerWidth={drawerWidth}
        isDrawerOpen={isDrawerOpen}
        setIsDrawerOpen={setIsDrawerOpen}
      >
        <RequiredModels />
        <TopNotifications />
        {children}
      </SideDrawer>
    </Box>
  );
};
